import {
  canShowScopedResource,
  type ResourceScope,
  type ResourceStatus,
} from '../scopedResource';

export const canShowMemberInfo = ({
  pageOwnerAui,
  memberInfoOwnerAui,
  memberInfoScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  memberInfoOwnerAui: string | null;
  memberInfoScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: memberInfoOwnerAui,
    resourceScope: memberInfoScope,
    currentScope,
    status,
  });

export const canShowCareerList = ({
  pageOwnerAui,
  listOwnerAui,
  listScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  listOwnerAui: string | null;
  listScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: listOwnerAui,
    resourceScope: listScope,
    currentScope,
    status,
  });

export const canShowAboutPageSetting = ({
  pageOwnerAui,
  settingOwnerAui,
  settingScope,
  currentScope,
  status,
}: {
  pageOwnerAui: string | null | undefined;
  settingOwnerAui: string | null;
  settingScope: ResourceScope | null;
  currentScope: ResourceScope;
  status: ResourceStatus;
}): boolean =>
  canShowScopedResource({
    pageOwnerAui,
    resourceOwnerAui: settingOwnerAui,
    resourceScope: settingScope,
    currentScope,
    status,
  });

/** CareerSection 순서는 About setting이 확인된 경우에만 신뢰할 수 있다. */
export const canShowOrderedCareerSections = ({
  canShowCareerData,
  canShowAboutSetting,
}: {
  canShowCareerData: boolean;
  canShowAboutSetting: boolean;
}): boolean => canShowCareerData && canShowAboutSetting;
